import React from 'react';

export function UniverseWordmark({ onActivate }: { onActivate: () => void }) {
  return <button type="button" className="universe-activation-wordmark" onClick={onActivate} aria-label="Open the Overture Universe">
    <span className="universe-title-star" aria-hidden="true"><svg viewBox="0 0 40 40" focusable="false"><path d="M20 1 Q23 16 39 20 Q23 24 20 39 Q17 24 1 20 Q17 16 20 1Z" fill="currentColor" /></svg></span>
    <span className="wordmark-overture" aria-hidden="true">{'Overture'.split('').map((letter, index) => <span key={index} style={{ '--letter-delay': `${index * 65}ms` } as React.CSSProperties}>{letter}</span>)}</span>
    <span className="wordmark-universe" aria-hidden="true">Universe</span>
  </button>;
}
